import { useDispatch, useSelector } from "react-redux";
import { fetchPrivacy as fetchPriv, fetchTyC } from "_config/store/app/app.thunk";

const useApp = () => {
  const dispatch = useDispatch();
  const { data: privacy, error: privacyError, isLoading: privacyIsLoading } = useSelector((s) => s.app.privacy);
  const { data: terms, error: termsError, isLoading: tycIsLoading } = useSelector((s) => s.app.tyc);
  const {
    data: lookAndFeel,
    error: lookAndFeelError,
    isLoading: lookAndFeelIsLoading
  } = useSelector((s) => s.app.lookAndFeel);

  const fetchTerms = () => dispatch(fetchTyC());

  const fetchPrivacy = () => dispatch(fetchPriv());

  return {
    fetchPrivacy,
    fetchTerms,
    lookAndFeel,
    lookAndFeelError,
    lookAndFeelIsLoading,
    privacy,
    privacyError,
    privacyIsLoading,
    terms,
    termsError,
    tycIsLoading
  };
};

export default useApp;
